import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export enum IconButtonTheme {
    White = 'white',
    Red = 'red',
    Blue = 'blue',
    Transparent = 'transparent',
}

export enum IconButtonSize {
    Small = 'small',
    Medium = 'medium',
}

export const IconButton: React.FC<{
    id: string;
    theme: IconButtonTheme;
    size: IconButtonSize;
    disabled?: boolean;
    icon: IconDefinition;
    handleClick?: React.MouseEventHandler;
    hint?: string;
    bubbleNumber?: number;
}> = ({ id, theme, handleClick, size, icon, hint, bubbleNumber, disabled }) => {
    const setStyle = {
        cursor: `${disabled ? 'arrow' : 'pointer'}`,
    };

    return (
        <>
            <div
                id={id}
                className={`iconButton ${theme} ${size} ${disabled ? 'disabled' : ''}`}
                style={setStyle}
                onClick={!disabled ? handleClick : undefined}
                title={hint}
            >
                <FontAwesomeIcon
                    icon={icon}
                    className='iconButton-image'
                />
                {bubbleNumber && <div className={`iconButton-bubble`}>{bubbleNumber > 99 ? '99+' : bubbleNumber}</div>}
            </div>
        </>
    );
};
